if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.galleryKeyboard = this.onGalleryKey.bind(this);
      }

      connectedCallback() {
        super.connectedCallback();
        document.addEventListener('keydown', this.galleryKeyboard, true);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.galleryKeyboard, true);
      }

      onGalleryKey(event) {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (event.target.closest('input, textarea, select, [contenteditable="true"], video, model-viewer')) return;
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        if (this.hasAttribute('open')) {
          const items = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
          if (items.length < 2) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const index = Math.max(0, items.findIndex(item => item.classList.contains('active')));
          const next = items[(index + direction + items.length) % items.length];
          window.pauseAllMedia();
          items.forEach(item => item.classList.toggle('active', item === next));
          const gallery = document.getElementById('MediaGallery-' + this.dataset.section);
          const opener = gallery?.querySelector('button[data-media-id="' + next.dataset.mediaId + '"]');
          if (opener) this.openedBy = opener;
          const content = this.querySelector('[role="document"]');
          content.scrollTop = 0;
          content.scrollLeft = 0;
          if (next.tagName === 'DEFERRED-MEDIA') next.loadContent?.();
          return;
        }
        if (document.querySelector('product-modal[open], details-modal details[open], cart-drawer.active')) return;
        const gallery = document.getElementById('MediaGallery-' + this.dataset.section);
        if (!gallery) return;
        const list = gallery.querySelector('.product__media-list');
        if (!list) return;
        if (!this.pageGalleryItems || this.pageGalleryItems.some(item => !list.contains(item))) {
          this.pageGalleryItems = Array.from(list.querySelectorAll(':scope > [data-media-id]'));
        }
        const items = this.pageGalleryItems.filter(item => !item.classList.contains('product__media-item--variant') || item.classList.contains('is-active'));
        if (items.length < 2) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const index = Math.max(0, items.findIndex(item => item.classList.contains('is-active')));
        const next = items[(index + direction + items.length) % items.length];
        if (gallery.dataset.desktopLayout === 'stacked' && window.matchMedia('(min-width: 750px)').matches) {
          list.prepend(next);
          next.classList.remove('scroll-trigger--offscreen');
        }
        gallery.setActiveMedia(next.dataset.mediaId, false);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
